export function accessTokenIsPresent() {
	const accessToken = localStorage.getItem('access_token');
	return !!accessToken;
}
